import { Redirect, Route } from "react-router-dom";
import { getCookieUtil } from "../../utils/getCookieUtil";

export default function PrivateRoute ({ children, ...rest }) {
    return (
        <Route
            {...rest}
            render={({ location }) =>
                getCookieUtil('token') ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: "/register",
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    );
}
